module.exports = __webpack_public_path__ + "img/chips1.e6ef336f.webp";